import {
  createManagerOrderComment,
  getManagerOrderCommentLinks,
  getManagerOrderComments
} from '../../../api/commentApi';
import {
  type ICommentResponse,
  type ICreateCommentData,
  type ICommentListResponse,
  type ICommentLinksResponse,
  type ICommentLinksRequest
} from '@/types/IComment';
import { getErrorData, type IErrorData } from '../../../utils/getErrorData';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getOrderCommentsThunk = createAsyncThunk<
  ICommentListResponse,
  { orderUuid: string; limit?: number; offset?: number; append?: boolean },
  { rejectValue: IErrorData }
>(
  'comments/getOrderCommentsThunk',
  async ({ orderUuid, limit, offset }, { rejectWithValue }) => {
    try {
      const response = await getManagerOrderComments(orderUuid, {
        limit,
        offset
      });

      return response;
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);

export const createOrderCommentThunk = createAsyncThunk<
  ICommentResponse,
  ICreateCommentData,
  { rejectValue: IErrorData }
>('comments/createOrderCommentThunk', async (data, { rejectWithValue }) => {
  try {
    const response = await createManagerOrderComment(data);

    return response;
  } catch (error) {
    const errorData = getErrorData(error);
    return rejectWithValue(errorData);
  }
});

export const getCommentLinksThunk = createAsyncThunk<
  { commentId: string; links: ICommentLinksResponse; orderUuid: string },
  { commentId: string; orderUuid: string; data: ICommentLinksRequest },
  { rejectValue: IErrorData }
>(
  'comments/fetchCommentLinks',
  async ({ commentId, orderUuid, data }, { rejectWithValue }) => {
    try {
      const response = await getManagerOrderCommentLinks(commentId, data);

      return { commentId, links: response, orderUuid };
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);
